import { Dataset, DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import { SchemaField, FieldDataType } from 'src/app/modules/core/store/models/document.model';

export class DatasetRelationHelper {
  constructor() {}

  private relatedFromToTypes: any[] = [
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.Intelligence,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.Rating,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.Weather,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.TropicalCyclone,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.Wildfire,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.Earthquake,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },
    {
      fromType: DatasetType.Alerts, fromSubtype: DatasetSubtype.MobileEvent,
      toType: DatasetType.Incident, toSubtype: DatasetSubtype.None
    },


    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.Intelligence
    },
    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.Rating
    },
    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.Weather
    },
    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.TropicalCyclone
    },
    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.Wildfire
    },
    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.Earthquake
    },
    {
      fromType: DatasetType.Incident, fromSubtype: DatasetSubtype.None,
      toType: DatasetType.Alerts, toSubtype: DatasetSubtype.MobileEvent
    }
  ];

  public getRelatedParentFieldByDataset(fromDataset: Dataset, toDataset: Dataset): SchemaField {
    // get it based on toDataset
    let ret: SchemaField = null;
    fromDataset.schema.fields.filter(f => f.dataType === FieldDataType.RelatedParent).forEach(f => {
      if (toDataset.type === f.settings.relatedDatasetType && toDataset.subtype === f.settings.relatedDatasetSubType) {
        ret = f;
        return f;
      }
    });

    return ret;
  }

  public getRelatedParentFieldByDocument(dataset: Dataset, document: any): SchemaField {
      // get it based on existing field settings and allowed types
      const relTypeDefs = this.relatedFromToTypes.filter(r => r.fromType === dataset?.type && r.fromSubtype === dataset?.subtype);
      if (!(relTypeDefs.length > 0)) {
        return null;
      }

      let ret: SchemaField = null;
      dataset.schema.fields.filter(f => f.dataType === FieldDataType.RelatedParent).forEach(f => {
        if (relTypeDefs.find(r => r.toType === f.settings.relatedDatasetType) && relTypeDefs.find(r => r.toSubtype === f.settings.relatedDatasetSubType)
          && document[f.systemName] !== undefined) {
          ret = f;
          return f;
        }
      });

      return ret;
  }

  public getRelatedDatasetTypeByDataset(fromDataset: Dataset, toDataset: Dataset): { type: DatasetType, subtype: DatasetSubtype } {
    // get it based on toDataset
    const relTypeDef = this.relatedFromToTypes.find(r => r.fromType === fromDataset?.type && r.fromSubtype === fromDataset?.subtype
      && r.toType === toDataset?.type && r.toSubtype === toDataset?.subtype);
    if (!relTypeDef) {
      return null;
    }
    else {
      return ({ type: relTypeDef.toType, subtype: relTypeDef.toSubtype });
    }
  }

  public getRelatedDatasetTypeByDocument(fromDataset: Dataset, document: any): { type: DatasetType, subtype: DatasetSubtype } {
    // get it based on existing field settings and allowed types
    const relTypeDefs = this.relatedFromToTypes.filter(r => r.fromType === fromDataset?.type && r.fromSubtype === fromDataset?.subtype);
    if (!(relTypeDefs.length > 0)) {
      return null;
    }

    const parentFields = fromDataset.schema.fields.filter(f => f.dataType === FieldDataType.RelatedParent);

    let ret: { type: DatasetType, subtype: DatasetSubtype } = { type: 0, subtype: 0};

    parentFields.forEach(pf => {
      if (relTypeDefs.find(r => pf.settings?.relatedDatasetType === r.toType && pf.settings?.relatedDatasetSubType === r.toSubtype)
        && document[pf.systemName] !== undefined) {
        ret = { type: pf.settings.relatedDatasetType, subtype: pf.settings.relatedDatasetSubType };
        return ret;
      }
    })

    return ret;
  }
}
